import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bracket'
})
export class BracketPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return `(${value})`;
  }
}
